import { render, staticRenderFns } from "./UploadsCard.vue?vue&type=template&id=2198756d&"
import script from "./UploadsCard.vue?vue&type=script&lang=js&"
export * from "./UploadsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports